module.exports = __webpack_public_path__ + "static/media/paybychex.10f269dd.png";